import api from './api'
import { AttitudeCategory } from './types'

export const attitudesService = {
  /**
   * Get all attitude categories
   */
  async getAll(): Promise<AttitudeCategory[]> {
    const response = await api.get<AttitudeCategory[]>('/attitude-categories/')
    return response.data
  },

  /**
   * Get attitude categories by type
   */
  async getByType(type: 'positive' | 'negative'): Promise<AttitudeCategory[]> {
    const response = await api.get<AttitudeCategory[]>('/attitude-categories/', {
      params: { type },
    })
    return response.data
  },
}

export default attitudesService
